import dealsApi from '@/api/deals';

const state = {
    failureTypes: null,
    deal: null,
    isLoading: false,
    validationErrors: null,
}

export const mutationTypes = {
    createDealStart: '[deals] Create deal start',
    createDealSuccess: '[deals] Create deal success',
    createDealFailure: '[deals] Create deal failure',

    updateStageStart: '[deals] Update stage start',
    updateStageSuccess: '[deals] Update stage success',
    updateStageFailure: '[deals] Update stage failure',

    updateSuccessStart: '[deals] Update success start',
    updateSuccessSuccess: '[deals] Update success success',
    updateSuccessFailure: '[deals] Update success failure',

    updateFailureStart: '[deals] Update failure start',
    updateFailureSuccess: '[deals] Update failure success',
    updateFailureFailure: '[deals] Update failure failure',

    failureTypesStart: '[deals] Failure types start',
    failureTypesSuccess: '[deals] Failure types success',
    failureTypesFailure: '[deals] Failure types failure',
}

export const dealsActionTypes = {
    createDeal: '[deals] Create deal',
    updateStage: '[deals] Update stage',
    updateSuccess: '[deals] Update success',
    updateFailure: '[deals] Update failure',
    failureTypes: '[deals] Failure types'
}

const mutations = {
    [mutationTypes.createDealStart](state) {
        state.isLoading = true
        state.deal = null
    },
    [mutationTypes.createDealSuccess](state, payload) {
        state.isLoading = false
        state.deal = payload
        state.validationErrors = null
    },
    [mutationTypes.createDealFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.updateStageStart](state) {
        state.isLoading = true
        state.deal = null
    },
    [mutationTypes.updateStageSuccess](state, payload) {
        state.isLoading = false
        state.deal = payload
        state.validationErrors = null
    },
    [mutationTypes.updateStageFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.updateSuccessStart](state) {
        state.isLoading = true
        state.deal = null
    },
    [mutationTypes.updateSuccessSuccess](state, payload) {
        state.isLoading = false
        state.deal = payload
        state.validationErrors = null
    },
    [mutationTypes.updateSuccessFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.updateFailureStart](state) {
        state.isLoading = true
        state.deal = null
    },
    [mutationTypes.updateFailureSuccess](state, payload) {
        state.isLoading = false
        state.deal = payload
        state.validationErrors = null
    },
    [mutationTypes.updateFailureFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.failureTypesStart](state) {
        state.isLoading = true
        state.failureTypes = null
    },
    [mutationTypes.failureTypesSuccess](state, payload) {
        state.isLoading = false
        state.failureTypes = payload
        state.validationErrors = null
    },
    [mutationTypes.failureTypesFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
}

const actions = {
    [dealsActionTypes.createDeal](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.createDealStart)
            dealsApi
                .createDeal(data)
                .then(response => {
                    context.commit(mutationTypes.createDealSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.createDealFailure,response)
                })
        })
    },
    [dealsActionTypes.updateStage](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.updateStageStart)
            dealsApi
                .updateStage(data)
                .then(response => {
                    context.commit(mutationTypes.updateStageSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.updateStageFailure,response)
                })
        })
    },
    [dealsActionTypes.updateSuccess](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.updateSuccessStart)
            dealsApi
                .updateSuccess(data)
                .then(response => {
                    context.commit(mutationTypes.updateSuccessSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.updateSuccessFailure,response)
                })
        })
    },
    [dealsActionTypes.updateFailure](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.updateFailureStart)
            dealsApi
                .updateFailure(data)
                .then(response => {
                    context.commit(mutationTypes.updateFailureSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.updateFailureFailure,response)
                })
        })
    },
    [dealsActionTypes.failureTypes](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.failureTypesStart)
            dealsApi
                .failureTypes(data)
                .then(response => {
                    context.commit(mutationTypes.failureTypesSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.failureTypesFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}